import React, { useState } from 'react';
import { Typography } from '@hpstellar/core';
import { Info } from '@hpstellar/icons';
import { X } from '@hpstellar/vis-icons';
import { ButtonIcon } from '@hpstellar/core/visId';

import './filter-notice.less';

export default function FilterNotice() {
    const [close, setClose] = useState(false);

    if (close) {
        return null;
    }

    return (
        <div className="filterNotice">
            <div className="filterNotice-info">
                <Info size="s" />
            </div>
            <Typography className="filterNotice-content" variant="bodyS">
                Selecting filters will refresh results and may change available options.
            </Typography>
            <ButtonIcon
                className="filterNotice-close"
                icon={<X size="s" />}
                background="transparent"
                hasBorder={false}
                onClick={() => setClose(true)}
            />
        </div>
    );
}
